import React from "react";
import { useAppMeta } from "hooks";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import DeconsolidationForm from "./DeconsolidationComponents/DeconsolidationForm";

import {
    useGetDeconsolidationDetailQuery,
    useUpdateDeconsolidationMutation,
} from "store/services/deconsolidationApi";

const DeconsolidationEditScreen = () => {
    const { id } = useParams();

    const navigate = useNavigate();

    const breadcrumbs = [
        { title: "Deconsolidation", path: "/app/crm/deconsolidation/list" },
        { title: "Edit Deconsolidation" },
    ];

    const {
        data: deconsolidationDetail,
        isLoading: loadingDeconsolidation,
        error,
    } = useGetDeconsolidationDetailQuery(id);

    const [updateDeconsolidation, { isLoading: updatingDeconsolidation }] =
        useUpdateDeconsolidationMutation();

    const handleUpdateDeconsolidation = async (data) => {
        const _payload = { ...data, _id: id };

        try {
            await updateDeconsolidation(_payload).unwrap();
            toast.success("Deconsolidation successfully updated!");
            navigate(`/app/crm/deconsolidation/${id}/detail`);
        } catch (err) {
            toast.error(
                err?.data?.message ?? err?.message ?? "Couldn't update Deconsolidation!"
            );
        }
    };

    useAppMeta("Edit Deconsolidation");

    return (
        <BreadcrumbLayout
            breadcrumbs={breadcrumbs}
            isBusy={loadingDeconsolidation || updatingDeconsolidation}
        >
            <BreadcrumbLayout.Error error={error} />
            <BreadcrumbLayout.Paper>
                <DeconsolidationForm
                    isBusy={loadingDeconsolidation || updatingDeconsolidation}
                    deconsolidationDetail={deconsolidationDetail}
                    onSubmit={handleUpdateDeconsolidation}
                />
            </BreadcrumbLayout.Paper>
        </BreadcrumbLayout>
    );
};

export default DeconsolidationEditScreen;